<div class="level-icon" [ngClass]="{'low': level === 1, 'medium': level === 2, 'high': level === 3}">
  <div class="level-icon__bar" [ngClass]="{'active': idx < level}" *ngFor="let levelItem of [].constructor(3); index as idx">
  </div>
</div>
